import React from 'react';
import { string, node, bool } from 'prop-types';
import useStyles from '../../hooks/useStyles';

TextInfo.propTypes = {
	className: string,
	children: node,
	validity: bool
};

export default function TextInfo({ className, children, validity }) {
	const classes = useStyles(styles);
	return (
		<p css={[classes.root, validity === false && classes.invalid]} className={className}>
			{children}
		</p>
	);
}

function styles({ css, theme: { color } }) {
	return {
		root: css`
			font-size: 1.2rem;
			color: ${color.muted};
			margin: 4px 0 0;
		`,
		invalid: css`
			color: ${color.danger};
		`
	};
}
